import React from 'react'
import { useDispatch } from 'react-redux'
import { removeFromLocalStorage } from '@mobi/utils/storage'
import { resetTrustedDevicePrompt } from '@core/Areas/Login/Store'
import { ExpandableToolboxSection } from './Common/ExpandableToolboxSection'
import { Button } from '@mobi/component-library/Base/Buttons'

export const LocalStorageManager: React.FC = () => {
  const dispatch = useDispatch()
  const [localStorageState, setLocalStorageState] = React.useState<Record<string, string>>()

  React.useEffect(() => {
    setLocalStorageState(getLocalStorageForState())
  }, [])

  if (!localStorageState) return null

  const handleLocalStorageDelete = (key: string) => {
    removeFromLocalStorage(key)
    setLocalStorageState(getLocalStorageForState())
  }

  return (
    <ExpandableToolboxSection heading='Local Storage'>
      <div
        style={{
          fontSize: '1.4rem',
          padding: '1rem',
          wordBreak: 'break-all',
        }}
      >
        {Object.keys(localStorageState)
          .sort()
          .map(key => (
            <details key={key} style={{ marginBottom: '1rem' }}>
              <summary>
                {key}{' '}
                <Button
                  color='tertiary_grey'
                  size='xs'
                  onClick={() => handleLocalStorageDelete(key)}
                >
                  Delete
                </Button>
              </summary>

              {localStorageState[key].startsWith('{') ? (
                <pre>{JSON.stringify(JSON.parse(localStorageState[key]), null, 2)}</pre>
              ) : (
                localStorageState[key]
              )}
            </details>
          ))}
      </div>

      <div style={{ padding: '0.5rem' }}>
        <Button
          size='sm'
          color='primary_destructive'
          onClick={() => {
            dispatch(resetTrustedDevicePrompt())
            alert('Reset complete. Refresh page to reflect changes.')
          }}
        >
          Reset Trusted Device Prompt Delay
        </Button>
      </div>
    </ExpandableToolboxSection>
  )
}

// Local Helpers

function getLocalStorageForState() {
  const storageKeys: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    storageKeys.push(localStorage.key(i) as string)
  }
  const state = storageKeys.reduce<Record<string, string>>((acc, curr) => {
    acc[curr] = localStorage.getItem(curr) as string
    return acc
  }, {})
  return state
}
